import { createContext, useContext } from 'react';
import type { PortfolioSnapshot } from '@im-marina/shared';

/**
 * The snapshot the public pages render. The public site provides the published
 * `portfolio.json`; the admin preview provides a draft-inclusive one from the API.
 */
export const SnapshotContext = createContext<PortfolioSnapshot | null>(null);

export function useSnapshot(): PortfolioSnapshot {
  const snapshot = useContext(SnapshotContext);
  if (!snapshot) throw new Error('useSnapshot must be used inside a SnapshotContext provider');
  return snapshot;
}
